import Chart from './chart.js';
//import easyAutocomplete from './vendors/jquery.easy-autocomplete.min.js';
/****************************************************************************************************************************************************************

  General purpose Vars and functions

*****************************************************************************************************************************************************************/

function getURLParametersOfJsRef() {
  var scripts = document.getElementsByTagName('script');
  var myScript = scripts[scripts.length - 1];
  var query = myScript.src.replace(/^[^\?]+\??/, '');
  var Params = new Object();
  if (!query) return Params; // return empty object
  var Pairs = query.split(/[;&]/);
  for (var i = 0; i < Pairs.length; i++) {
    var KeyVal = Pairs[i].split('=');
    if (!KeyVal || KeyVal.length != 2) continue;
    var key = unescape(KeyVal[0]);
    var val = unescape(KeyVal[1]);
    val = val.replace(/\+/g, ' ');
    Params[key] = val;
  }
  return Params;
}

// Preset of Global Vars
var roiResultCollapsed = true,
  errorBorderColor = '#FF0000',
  noErrorBorderColor = '#D5D4CE',
  $vLang = $('html')[0].lang;
var pageLanguage, labelsChart;

if (undefined != $vLang && $vLang == 'en') {
  pageLanguage = 'en';
  labelsChart = ['Revenue', 'Net Profit', 'Total Cost'];
} else {
  pageLanguage = 'en'; //default value
  labelsChart = ['Ingreso', 'Ganancia Neta', 'Costo Total'];
}

/****************************************************************************************************************************************************************

  Chart initialization

*****************************************************************************************************************************************************************/

// Chart config
if ($('#roiChart').length > 0) {
  var ctx = $('#roiChart').get(0).getContext('2d'); // Get context and the first returned node
  var data = {
    labels: labelsChart,
    datasets: [
      {
        label: 'ROI results chart',
        fillColor: 'rgba(101,193,146,1)',
        strokeColor: 'rgba(0,0,0,0.8)',
        highlightFill: 'rgba(220,220,220,0.75)',
        highlightStroke: 'rgba(220,220,220,1)',
        data: [30, 40, 50],
      },
    ],
  };

  if (pageLanguage.toUpperCase() != 'ES') {
    data.labels = ['Revenue', 'Profit', 'Total Cost'];
  }

  var options = {
    //Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
    scaleBeginAtZero: true,

    // Boolean - If we want to override with a hard coded scale
    scaleOverride: false,

    // ** Required if scaleOverride is true **
    // Number - The number of steps in a hard coded scale
    scaleSteps: 10,
    // Number - The value jump in the hard coded scale
    scaleStepWidth: 1,
    // Number - The scale starting value
    scaleStartValue: 0,

    //Boolean - Whether grid lines are shown across the chart
    scaleShowGridLines: true,

    //String - Colour of the grid lines
    scaleGridLineColor: 'rgba(218,216,13,.05)',

    //Number - Width of the grid lines
    scaleGridLineWidth: 1,

    //Boolean - Whether to show labels on the scale
    scaleShowLabels: false,

    //Boolean - If there is a stroke on each bar
    barShowStroke: false,

    // Boolean - Whether to animate the chart
    animation: true,

    //Number - Spacing between each of the X value sets
    barValueSpacing: 10,

    // String - Tooltip label font declaration for the scale label
    tooltipFontFamily: "'Ubuntu', 'Helvetica', 'Arial', sans-serif",

    // String - Scale label font declaration for the scale label
    scaleFontFamily: "'Ubuntu', 'Helvetica', 'Arial', sans-serif",

    // Number - Scale label font size in pixels
    scaleFontSize: 15,

    // String - Scale label font weight style
    scaleFontStyle: '300',

    // String - Scale label font colour
    scaleFontColor: '#79725E',

    //String - A legend template
    legendTemplate:
      '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].lineColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>',
  };

  var myBarChart = new Chart(ctx).Bar(data, options);
}

/****************************************************************************************************************************************************************

  ROI Form Logic

*****************************************************************************************************************************************************************/

// Get Form inputs
var campaignAudienceSize = document.getElementById('subscribersQuantity');
var campaignCosts = document.getElementById('campaignCost');
var responseRate = document.getElementById('responseRate');
var conversionRate = document.getElementById('conversionRate');
var averageBuyerPurchase = document.getElementById('averageBuyerPurchase');

function manageFlow() {
  if (validateFields()) {
    calculateRoi();
    if (roiResultCollapsed) {
      $('#roiResultsMainContainer').slideDown('slow');
      roiResultCollapsed = false;
    }
    $('html,body').animate(
      {
        scrollTop: $('#roiResultsMainContainer').offset().top,
      },
      'slow',
    );
  }
}

if (document.getElementById('ctaCalculate')) {
  document.getElementById('ctaCalculate').onclick = function (e) {
    e.preventDefault(); // Prevent a page reload when a link is pressed
    manageFlow();
  };
}

function calculateRoi() {
  // Get result fields
  var var1 = document.getElementById('contactingCostResult');
  var var2 = document.getElementById('openRateResult');
  var var3 = document.getElementById('convertionRateResult');
  var var4 = document.getElementById('totalEarningResult');
  var var5 = document.getElementById('netEarningResult');
  var var6 = document.getElementById('costPerOpenEmailResult');
  var var7 = document.getElementById('costPerConvertionResult');
  var var8 = document.getElementById('roiResult');

  // Calculate
  var costPerContact = campaignCosts.value / campaignAudienceSize.value;
  var numberOfResponders =
    (responseRate.value * campaignAudienceSize.value) / 100;
  var numbersOfBuyers = (numberOfResponders * conversionRate.value) / 100;
  var revenue = averageBuyerPurchase.value * numbersOfBuyers;
  var profit = revenue - campaignCosts.value;
  var costPerResponder = campaignCosts.value / numberOfResponders;
  var costPerBuyer = campaignCosts.value / numbersOfBuyers;
  var roiPercentage = Math.round((profit * 100) / campaignCosts.value, 2);

  // Apply results
  var1.innerHTML =
    '<span class="sign">$</span>' + costPerContact.toFixed(2).replace('.', ',');
  var2.innerHTML = numberOfResponders.toFixed(2).replace('.', ',');
  var3.innerHTML = numbersOfBuyers.toFixed(2).replace('.', ',');
  var4.innerHTML =
    '<span class="sign">$</span>' + revenue.toFixed(2).replace('.', ',');
  var5.innerHTML =
    '<span class="sign">$</span>' + profit.toFixed(2).replace('.', ',');
  var6.innerHTML =
    '<span class="sign">$</span>' +
    costPerResponder.toFixed(2).replace('.', ',');
  var7.innerHTML =
    '<span class="sign">$</span>' + costPerBuyer.toFixed(2).replace('.', ',');
  var8.innerHTML =
    roiPercentage.toFixed(2).replace('.', ',') + '<span class="sign">%</span>';

  // Update chart
  myBarChart.datasets[0].bars[0].value = revenue.toFixed(2);
  myBarChart.datasets[0].bars[1].value = profit.toFixed(2);
  myBarChart.datasets[0].bars[1].fillColor = 'rgba(252,229,121,1)';
  myBarChart.datasets[0].bars[2].value = costPerBuyer.toFixed(2);
  myBarChart.datasets[0].bars[2].fillColor = 'rgba(238,156,112,1)';
  myBarChart.update();

  return false;
}

// Calculate on enter pressed
$(function () {
  $('form').each(function () {
    $(this)
      .find('input')
      .keypress(function (e) {
        // Enter pressed?
        if (e.which == 10 || e.which == 13) {
          manageFlow();
        }
      });
  });
});

/****************************************************************************************************************************************************************

  ROI Form Validations

*****************************************************************************************************************************************************************/

function validateNumber(event) {
  var key = window.event ? event.keyCode : event.which;

  if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 127) {
    return true;
  } else if (key < 48 || key > 57) {
    return false;
  } else return true;
}

function validateFields() {
  var fieldsOk = true;
  if (
    !campaignAudienceSize.value ||
    !isNumber(campaignAudienceSize.value) ||
    campaignAudienceSize.value < 0
  ) {
    fieldsOk = fieldsOk && false;
    campaignAudienceSize.parentNode.classList.add('input-error');
  } else {
    campaignAudienceSize.parentNode.classList.remove('input-error');
  }
  if (
    !campaignCosts.value ||
    !isNumber(campaignCosts.value) ||
    campaignCosts.value < 0
  ) {
    fieldsOk = fieldsOk && false;
    campaignCosts.parentNode.classList.add('input-error');
  } else {
    campaignCosts.parentNode.classList.remove('input-error');
  }
  if (
    !responseRate.value ||
    !isNumber(responseRate.value) ||
    responseRate.value < 0 ||
    responseRate.value > 100
  ) {
    fieldsOk = fieldsOk && false;
    responseRate.parentNode.classList.add('input-error');
  } else {
    responseRate.parentNode.classList.remove('input-error');
  }
  if (
    !conversionRate.value ||
    !isNumber(conversionRate.value) ||
    conversionRate.value < 0 ||
    conversionRate.value > 100
  ) {
    fieldsOk = fieldsOk && false;
    conversionRate.parentNode.classList.add('input-error');
  } else {
    conversionRate.parentNode.classList.remove('input-error');
  }
  if (
    !averageBuyerPurchase.value ||
    !isNumber(averageBuyerPurchase.value) ||
    averageBuyerPurchase.value < 0
  ) {
    fieldsOk = fieldsOk && false;
    averageBuyerPurchase.parentNode.classList.add('input-error');
  } else {
    averageBuyerPurchase.parentNode.classList.remove('input-error');
  }
  return fieldsOk;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

//Two-digits limit validation, for percentages fields
$(document).ready(function () {
  $('#averageBuyerPurchase,#campaignCost,#subscribersQuantity').keypress(
    validateNumber,
  );
  $('#conversionRate,#responseRate').keypress(function (event) {
    var key = window.event ? event.keyCode : event.which;
    if (
      validateNumber(event) &&
      !(event.keyCode == 8 || event.keyCode == 127)
    ) {
      if ($(this).val().indexOf('.') != -1) {
        if ($(this).val().split('.')[0].length > 2) {
          if (isNaN(parseFloat(this.value))) return;
          this.value = parseFloat(this.value).toFixed(2);
        }
        if ($(this).val().split('.')[1].length > 2) {
          if (isNaN(parseFloat(this.value))) return;
          this.value = parseFloat(this.value).toFixed(2);
        }
      } else {
        if ($(this).val() >= 0) {
          if ($(this).val().length > 2) {
            if (isNaN(parseFloat(this.value))) return;
            this.value = parseFloat(this.value).toFixed(2);
          }
        }
      }
      return this; //for chaining
    } else {
      return false;
    }
  });
});

//Form row colors controller
$('input').focusin(function () {
  $(this).closest('.roi--item').removeClass('input-error');
  $(this)
    .closest('.roi--group')
    .find('.roi--item:first-child')
    .addClass('selected');
  $(this).closest('.roi--item').addClass('input-focused');
});

$('input').focusout(function () {
  $(this)
    .closest('.roi--group')
    .find('.roi--item:first-child')
    .removeClass('selected');
  $(this).closest('.roi--item').removeClass('input-focused');
});
